export default __webpack_public_path__ + "static/media/shutdown.ee31f59a.ogg";